import React, {memo} from 'react';
import {Button} from "reactstrap";
import {
    ConfirmationText,
    CongratulationsText,
    ContentWrapper,
    PaymentSuccessContainer,
    OrderStatusIcon,
    SuccessMessage,
    Title
} from "../../orderComplete.style";

const FailedIconSVG = memo(() => (
    <svg width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_4282_6204" style={{maskType: "luminance"}} maskUnits="userSpaceOnUse" x="19" y="8" width="92" height="114">
            <path d="M27.0832 119.165H102.917C104.353 119.165 105.731 118.595 106.747 117.579C107.762 116.563 108.333 115.185 108.333 113.749V37.9154H81.2498V10.832H27.0832C25.6466 10.832 24.2688 11.4027 23.253 12.4185C22.2372 13.4344 21.6665 14.8121 21.6665 16.2487V113.749C21.6665 115.185 22.2372 116.563 23.253 117.579C24.2688 118.595 25.6466 119.165 27.0832 119.165Z" fill="#555555" stroke="#FAD200" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M81.25 10.832L108.333 37.9154M48.75 59.582L81.25 92.082M81.25 59.582L48.75 92.082" stroke="#FAD200" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </mask>
        <g mask="url(#mask0_4282_6204)">
            <path d="M0 0H130V130H0V0Z" fill="#F04848"/>
        </g>
    </svg>
));

const SplitBuyPaymentFailed = memo(() => {
    return (
        <PaymentSuccessContainer>
            <ContentWrapper>
                <Title>Split Buy Payment</Title>
                <OrderStatusIcon>
                    <FailedIconSVG/>
                </OrderStatusIcon>

                <SuccessMessage>
                    <CongratulationsText>
                        Payment Failed! Let’s Try Again
                    </CongratulationsText>
                    <ConfirmationText>
                        It looks like your payment didn’t go through,<br/>
                        so your membership to the split-buying group <br/>
                        isn’t active just yet.
                    </ConfirmationText>
                </SuccessMessage>
            </ContentWrapper>
            <a href="/split-buy" className={"mobile-sticky-checkout"}>
                <Button  className={"custom-app-btn"}>
                    Re-Direct To Home
                </Button>
            </a>

        </PaymentSuccessContainer>
    );
})
export default SplitBuyPaymentFailed;